import { ReactElement } from 'react';

const SealIcon = (): ReactElement => {
    return (
        <span id="siteseal">
            <script async type="text/javascript" src="https://seal.godaddy.com/getSeal?sealID=1jZIjBTB8iKw0uJ6MGQWGtbxRYmuTjzqYKxx8KhqNrlkcbCKQpM12jUGaC5f"></script>
        </span>
    );
};

export default SealIcon;
